import { useEffect, useState, useRef } from 'react'
import {
  CircularProgressbarWithChildren,
  buildStyles,
} from 'react-circular-progressbar'
import 'swiper/css/bundle'
import 'swiper/css'

import { MdOutlineExpandLess } from 'react-icons/md'
import { MdOutlineExpandMore } from 'react-icons/md'
import { getBboxFromGeoJson } from '../hooks/utils'
import Moment from 'react-moment'

import { useNavigate, useSearchParams } from 'react-router-dom'
import { FaShare, FaTrash } from 'react-icons/fa'
import { IoMdDownload } from 'react-icons/io'
import ParcelCardView from './ParcelCardView'
import { MapProvider, Map, Source, Layer } from 'react-map-gl/maplibre'
import ranchApnLayers from '../hooks/ranchApnLayers'
import { callAPI } from '../hooks/api'
import { toast } from 'react-toastify'
import spinner from '../assets/svg/spinner.svg'
import { toJpeg } from 'html-to-image'
import { pdf } from '@react-pdf/renderer'
import Spinner from './Spinner'
import { useAuth } from '../hooks/getAuth'
import DeletePopupModal from './DeletePopupModal'
import { isMobile, isSafari } from 'react-device-detect'
import { FaCircleInfo } from 'react-icons/fa6'
import scoreHoverText from '../hooks/scoreHoverText'
import MobileRanchCardView from './MobileRanchCardView'
import useAbility from '@/hooks/use-ability'
import { toPng } from 'html-to-image'
import { RanchReportPDF } from '@/pages/pdf/pdf-report-ranch'
import { showReportLimitToast } from './toast/report-limit-toast'
import UpgradeLockIconLayout from './upgrade-lock-icon-layout'
import GenerateFloodMaps from '../pages/pdf/_components/generate-flood-map'
import { base64ToBlobUrl } from '@/pages/pdf/_data/helper'
import { ETierKey } from '@/pages/subscribe/_data/subscribe-constant'
import { useQueryState } from 'nuqs'
import {
  TrialLimitType,
  TRIAL_LIMIT_QUERY_KEY,
} from './trial-modal/trial-limit-modal'

export default function RanchCardView({
  currentTab,
  ranch,
  ranches,
  ranchParcels,
  setRanchParcels,
  selectedRanch,
  setSelectedRanch,
  logout,
  localAuth,
  clearRanchSelection,
  onRanchDelete,
  onEdit,
  onPropertyClicked,
  isDemoUser,
  setPopupContent,
  report = {},
  ranchSummary = {},
}) {
  const runReportRef = useRef(null)
  const [searchParams, setSearchParams] = useSearchParams()
  const [deletePopupModal, setDeletePopupModal] = useState(false)
  const mapRef = useRef(null)
  const [loading, setLoading] = useState(false)
  const [loadingPage, setLoadingPage] = useState(false)
  const [mapLoaded, setMapLoaded] = useState(false)
  const [mapIdle, setMapIdle] = useState(false)
  const [runReport, setRunReport] = useState(false)
  const [_, setTrialLimitState] = useQueryState(TRIAL_LIMIT_QUERY_KEY)

  const [ranchGeojson, setRanchGeojson] = useState({
    type: 'FeatureCollection',
    features: [],
  })
  const [reportPDF, setReportPDF] = useState({})
  const { auth } = useAuth()
  const {
    checkAbility,
    getAbilityReport,
    getAbilityLimit,
    getAbilityOptionalLimit,
    invalidateQuery,
  } = useAbility()

  const getSelectedRanchById = (ranchId) => {
    return ranches.find((ranch) => ranch.ranch_id == ranchId)
  }

  const [summary, setSummary] = useState({
    'Ranch Name': ranch.ranch_name,
    'Total Valuation': 0,
    'Total Acres': 0,
    'Acres Poor Rating': 0,
    'Acres Poor Rating SS': 0,
    'Aggregate HydraSCORE': 0,
    'Geometrically Weighted Aggregate HydraSCORE': 0,
    'Geometrically Weighted Aggregate SS': 0,
    'Watershed(s)': [],
    'Hydrologic Region(s)': [],
    'County(ies)': [],
    'Water District(s)': [],
    'GSA(s)': [],
    old_hs_avg: 0,
    hs_changed: false,
    hs_updated_time: 0,
  })

  useEffect(() => {
    if (Object.keys(ranchSummary).length > 0) {
      setSummary(ranchSummary)
    }
  }, [ranchSummary])

  const [ranchApnSource, setRanchApnSource] = useState({})
  const [ranchApnLayer, setRanchApnLayer] = useState({})
  const [ranchApnOutlineLayer, setRanchApnOutlineLayer] = useState({})
  const [ranchApnLabelLayer, setRanchApnLabelLayer] = useState({})
  const [mapBounds, setMapBounds] = useState([[], []])

  // FloodMap Report
  const [floodMapData, setFloodMapData] = useState()

  const navigate = useNavigate()

  const ranchId = Number(searchParams.get('ranchId'))
  const transactionId = String(searchParams.get('transactionId'))
  const purchaseToken = String(searchParams.get('purchaseToken'))
  const productId = String(searchParams.get('productId'))

  const sendMessageToReactNative = (status) => {
    if (ranchId) {
      setSearchParams((prevParams) => {
        const newParams = new URLSearchParams(prevParams)
        newParams.set('status', JSON.stringify(status))
        return newParams
      })
    }

    const message = {
      type: 'FROM_WEBVIEW',
      status: status,
      filePDF: {},
    }

    if (window.ReactNativeWebView) {
      if (ranchId) {
        setTimeout(() => {
          window.ReactNativeWebView.postMessage(JSON.stringify(message))
        }, [2000])
      } else {
        window.ReactNativeWebView.postMessage(JSON.stringify(message))
      }
    }
  }

  const layerStyle = {
    id: 'Google Satellite Hybrid',
    type: 'raster',
    source: 'google_earth_hybrid',
    layout: { visibility: 'visible' },
  }

  function hydraScoreColor(hydraScore) {
    if (hydraScore >= 93) return '#008000'
    else if (hydraScore >= 79) return '#8FB935'
    else if (hydraScore >= 68) return '#E6E22E'
    else if (hydraScore >= 48) return '#E09C3B'
    else if (hydraScore === 'NR') return '#808080'
    else return '#E64747'
  }

  const fitToMapBounds = () => {
    if (mapRef.current && mapBounds[0].length > 0) {
      mapRef.current.fitBounds(mapBounds, { padding: 100, duration: 1000 })
    }
  }

  useEffect(() => {
    if (mapLoaded) fitToMapBounds()
  }, [mapLoaded, mapBounds])

  useEffect(() => {
    if (ranchGeojson.features.length) {
      var {
        ranchApnSource,
        ranchApnLayer,
        ranchApnOutlineLayer,
        ranchApnLabelLayer,
      } = ranchApnLayers(mapRef.current, ranchGeojson)
      setRanchApnSource(ranchApnSource)
      setRanchApnLayer(ranchApnLayer)
      setRanchApnOutlineLayer(ranchApnOutlineLayer)
      setRanchApnLabelLayer(ranchApnLabelLayer)
      var bbox = getBboxFromGeoJson(ranchGeojson)

      const getBoundingBox = (coordinates) => {
        const minLat = Math.min(...coordinates.map((coord) => coord[0]))
        const maxLat = Math.max(...coordinates.map((coord) => coord[0]))
        const minLon = Math.min(...coordinates.map((coord) => coord[1]))
        const maxLon = Math.max(...coordinates.map((coord) => coord[1]))

        return [
          [minLon, minLat],
          [maxLon, maxLat],
        ]
      }

      setMapBounds(
        getBoundingBox([
          [bbox[1], bbox[0]],
          [bbox[3], bbox[2]],
        ])
      )
    }
  }, [ranchGeojson])

  const getSummary = () => {
    if (
      ranchParcels.updateRanchId !== 0 &&
      ranchParcels.updateRanchId === ranch.ranch_id &&
      ranchParcels.updateRanchId === selectedRanch.ranch_id
    ) {
      setLoading(true)
      const endpoint = '/get_portfolio_summary'
      const params = {
        ranch_id: ranch.ranch_id.toString(),
        return_update: ranchParcels.updateRanchId === ranch.ranch_id,
        session_key: localAuth.sessionKey,
      }

      callAPI(endpoint, params)
        .then((res) => {
          setLoading(false)
          if (
            res.status === 'update successful' ||
            res.status === 'pg read successful'
          ) {
            if (!res.data['Acres Poor Rating SS']) {
              res.data['Acres Poor Rating SS'] = 0
            }
            setSummary(res.data)
          }
        })
        .catch(() => {
          setLoading(false)
        })
    }
  }

  useEffect(() => {
    if (Object.keys(report).length > 0) {
      const formattedDate = new Date(report.created_time)
        .toLocaleDateString('en-US', {
          year: 'numeric',
          month: '2-digit',
          day: '2-digit',
        })
        .replaceAll('/', '-')
      setReportPDF({
        report_id: report.report_id,
        download: report.ranch_name + ' (' + formattedDate + ').pdf',
      })
    }
  }, [report])

  const prevRanchParcels = useRef(ranchParcels)
  useEffect(() => {
    // Compare the previous value with the current value

    if (
      JSON.stringify(prevRanchParcels.current) !== JSON.stringify(ranchParcels)
    ) {
      // Check if ranchParcels[ranch.ranch_id] exists and call getSummary
      if (ranchParcels[ranch.ranch_id]) {
        getSummary()
      }

      // Update the ref to the current value
      prevRanchParcels.current = ranchParcels
    }
  }, [ranchParcels]) // Trigger the effect whenever ranchParcels changes

  useEffect(() => {
    if (
      ranchParcels[ranch.ranch_id] &&
      selectedRanch.ranch_id == ranch.ranch_id
    ) {
      setRanchGeojson({
        type: 'FeatureCollection',
        features: ranchParcels[ranch.ranch_id].map((parcel) => parcel.feature),
      })
    }
  }, [selectedRanch, ranchParcels])

  const onMapLoad = () => {
    if (mapRef.current) {
      mapRef.current.setGlyphs(
        'https://glyphs.hydrascore.com/assets/fonts/{fontstack}/{range}.pbf'
      )
      setMapLoaded(true)
    }
  }

  const onMapIdle = () => {
    if (mapRef.current) {
      setMapIdle(true)
    }
  }

  const currentTier = auth.tier.includes(' - ')
    ? auth.tier.split(' - ')[0]
    : auth.tier

  useEffect(() => {
    if (
      ranchParcels[ranch.ranch_id] !== undefined &&
      ranchParcels[ranch.ranch_id].length > 0 &&
      ranchId
    ) {
      const selectedRanch = getSelectedRanchById(ranchId)
      setSelectedRanch(selectedRanch)
      setRunReport(true)
    }
  }, [ranchParcels, ranchId])

  const onRunReportClick = () => {
    if (isDemoUser) {
      toast.warn('This action is not available for demo users.')
      return
    }


    if (!enableReportGeneration && currentTier === ETierKey.Trial) {
      return setTrialLimitState(TrialLimitType.REPORTS_NOT_INCLUDED)
    }

    if (numberOfReportRemain === 0) {
      showReportLimitToast({
        tier: currentTier,
        numberOfReport: numberOfReport,
      })
      return
    }

    if (runReportRef.current) {
      runReportRef.current.innerText = 'Processing...'
      runReportRef.current.disabled = true
    }
    setRunReport(true)
    setSelectedRanch(ranch)
  }

  useEffect(() => {
    const fetchData = async () => {
      if (floodMapData) {
        try {
          await runRanchReport()
        } catch (error) {
          toast.error('Failed to run the report. Please try again.')
        } finally {
          if (runReportRef.current) {
            runReportRef.current.innerText = 'Run Report'
            runReportRef.current.disabled = false
          }
        }
      }
    }

    fetchData()
  }, [floodMapData])

  function onRanchParcelDelete(parcelId, ranchId, parcelRefId) {
    var endpoint = '/delete_parcel_from_ranch'
    var params = {
      parcel_ref_id: parcelRefId,
      ranch_id: ranchId,
      session_key: localAuth.sessionKey,
    }
    setLoading(true)
    callAPI(endpoint, params)
      .then((res) => {
        setLoading(false)
        if (res.status === 'fail') {
          toast.warn(res.msg)
          setLoading(false)
          return
        } else if (res.status === 'expire') {
          toast.warn(res.msg)
          setLoading(false)
          logout()
          return
        } else {
          let deepCopy = JSON.parse(JSON.stringify(ranchParcels))
          deepCopy[ranchId] = deepCopy[ranchId].filter(
            (parcel) => parcel.id !== parcelId
          )
          deepCopy['updateRanchId'] = ranchId
          setRanchParcels(deepCopy)
        }
      })
      .catch((e) => {
        toast.warn('Something went wrong. Please try again later.')
        console.log(e)
        setLoading(false)
      })
  }

  function handlePropertyMouseOut() {
    if (Object.keys(ranchApnSource).length) {
      const updatedFeatures = ranchApnSource.data.features.map((feature) => {
        const { selected, ...updatedProperties } = feature.properties
        return {
          ...feature,
          properties: updatedProperties,
        }
      })

      const updatedRanchApnSource = {
        ...ranchApnSource,
        data: {
          ...ranchApnSource.data,
          features: updatedFeatures,
        },
      }
      setRanchApnSource(updatedRanchApnSource)
    }
  }

  function handlePropertyMouseOver(parcel) {
    handlePropertyMouseOut()
    if (ranchApnSource && parcel.type === 'ranch') {
      const updatedFeatures = ranchApnSource.data.features.map((feature) => {
        if (feature.id == parcel.id) {
          return {
            ...feature,
            properties: {
              ...feature.properties,
              selected: '#FFFF00',
            },
          }
        } else {
          const { selected, ...updatedProperties } = feature.properties
          return {
            ...feature,
            properties: updatedProperties,
          }
        }
      })
      const updatedRanchApnSource = {
        ...ranchApnSource,
        data: {
          ...ranchApnSource.data,
          features: updatedFeatures,
        },
      }

      setRanchApnSource(updatedRanchApnSource)
    }
  }

  const getImage = async (reportDiv) => {
    if (document.getElementById(reportDiv) === null) {
      return ''
    }

    if (isSafari || isMobile) {
      // console.log('Generating image for Safari or mobile')
      const element = document.getElementById(reportDiv)

      let dataUrl = ''
      const minDataLength = 2000000
      let i = 0
      const maxAttempts = 10

      while (dataUrl.length < minDataLength && i < maxAttempts) {
        try {
          dataUrl = await toPng(element, { quality: 0.1, cacheBust: true })
        } catch (error) {
          console.error('Error generating image:', error)
        }
        i += 1
      }

      return base64ToBlobUrl(dataUrl)
    }

    return toJpeg(document.getElementById(reportDiv)).then(function (dataUrl) {
      const base64ImageData = dataUrl
      return base64ToBlobUrl(base64ImageData)
    })
  }

  const saveReport = async (hydraScore, ss, pdfBase64) => {
    const endpoint = '/insert_report'
    var params = {
      ranch_id: ranch.ranch_id,
      pdf_base64: pdfBase64,
      hydra_score: hydraScore.toString(),
      ss: ss.toString(),
      ranch_acreage: summary['Total Acres'].toString(),
      counties: JSON.stringify(summary['County(ies)']),
      hover: summary['hover'],
      session_key: localAuth.sessionKey,
      transaction_id: transactionId,
      product_id: productId,
      purchase_token: purchaseToken,
    }
    setReportPDF({})
    return callAPI(endpoint, params)
      .then((res) => {
        if (res.status === 'fail') {
          toast.warn(res.msg)
          setLoading(false)
          sendMessageToReactNative(res)
        } else if (res.status === 'expire') {
          toast.warn(res.msg)
          setLoading(false)
          sendMessageToReactNative(res)
          logout()
        } else if (res.status === 'success') {
          invalidateQuery()
          const formattedDate = new Date(res.report[0].created_time)
            .toLocaleDateString('en-US', {
              year: 'numeric',
              month: '2-digit',
              day: '2-digit',
            })
            .replaceAll('/', '-')
          setReportPDF({
            report_id: res.report[0].report_id,
            download: res.report[0].ranch_name + ' (' + formattedDate + ').pdf',
          })
          sendMessageToReactNative(res)

          return res
        } else {
          sendMessageToReactNative(res)
          return false
        }
      })
      .catch(() => {
        setLoading(false)
      })
  }

  const generateLetterPdf = async (data) => {
    const ability = getAbilityReport()
    const blob = await pdf(
      <RanchReportPDF data={data} ability={ability} />
    ).toBlob()

    let base64String
    let reader = new FileReader()
    reader.readAsDataURL(blob)
    reader.onloadend = async () => {
      base64String = reader.result
      return await saveReport(
        data.summary['Geometrically Weighted Aggregate HydraSCORE'],
        data.summary['Geometrically Weighted Aggregate SS'],
        base64String
      )
    }
  }

  const getScoreImage = async (score, type) => {
    return fetch(`${type}/${score}.png`)
      .then((response) => response.blob())
      .then((blob) => {
        const url = URL.createObjectURL(blob)
        return url
      })
      .catch((error) => {
        console.error('Error fetching image:', error)
        return ''
      })
  }

  const getGeojsonWeatherPlots = async () => {
    const simplifiedFeatureCollection = {
      type: 'FeatureCollection',
      features: ranchGeojson.features.map((originalFeature) => {
        const { geometry, id, properties } = originalFeature
        const { latitude, longitude, parcel_id } = properties
        return {
          geometry,
          id,
          properties: { latitude, longitude, parcel_id },
        }
      }),
    }
    var endpoint = '/get_weather_plots_from_geojson'
    const today = new Date()

    // Combine the year, month, and day components to form the yyyymmdd string
    const dts = `${today.getFullYear() - 41}0101`
    const dte = `${today.getFullYear() - 1}1231`

    var params = {
      dts: dts,
      dte: dte,
      geojson_str: JSON.stringify(simplifiedFeatureCollection),
    }
    return callAPI(endpoint, params).then((res) => {
      return res
    })
  }

  // RUN THE RANCH REPORT
  const runRanchReport = async () => {
    const data = ranchParcels[ranch.ranch_id]

    // Transform data into the desired format
    const ranchExecutiveSummary = data.reduce((acc, item) => {
      const { hydrologic_info, gsa_info, wd_info } = item.feature.properties
      const addUniqueItems = (targetArray, newItems, uniqueKey) =>
        newItems.forEach((newItem) => {
          const exists = targetArray.some(
            (existing) => existing[uniqueKey] === newItem[uniqueKey]
          )
          if (!exists) {
            targetArray.push(newItem)
          }
        })

      const key = hydrologic_info.subbasin_no
      if (!acc[key]) {
        acc[key] = {
          hydrologic_info,
          gsa_info: [],
          wd_info: [],
        }
      }

      addUniqueItems(acc[key].gsa_info, gsa_info, 'gsa_name')
      addUniqueItems(acc[key].wd_info, wd_info, 'wd_name')

      return acc
    }, {})

    //Deplay to make sure ranch-aerial-view is ready to be rendered
    await new Promise((resolve) => setTimeout(resolve, 1000))
    const aerialView = await getImage('ranch-aerial-view')
    setLoadingPage(true)

    // Never put setLoading below this line. It will cover the property detail page and getElementById will return null.
    try {
      // const ranchExecutiveSummary = await getRanchExecutiveSummary(result)
      // const weatherPlots = await getGeojsonWeatherPlots()
      const updatedRanchParcels = await Promise.all(
        ranchParcels[ranch.ranch_id].map(async (item) => {
          return {
            ...item,
            data: {
              ...item.data,
            },
          }
        })
      )

      updatedRanchParcels.sort((a, b) => {
        // Compare county_name
        if (a.feature.properties.county_name < b.feature.properties.county_name)
          return -1
        if (a.feature.properties.county_name > b.feature.properties.county_name)
          return 1

        // If county_name is the same, compare parcel_id
        if (a.feature.properties.parcel_id < b.feature.properties.parcel_id)
          return -1
        if (a.feature.properties.parcel_id > b.feature.properties.parcel_id)
          return 1

        return 0 // Objects are equal
      })

      const floodRiskImage = await getImage(`floodMap-Report`)

      const payload = {
        'aerial-view': aerialView,
        summary: summary,
        parcels: updatedRanchParcels,
        executive_summary: ranchExecutiveSummary,
        legend: await getScoreImage('new legend', 'img'),
        generatedBy: auth.name,
        // weatherPlots: weatherPlots.response,
        isMobile: isMobile,
        floodRiskImage: floodRiskImage,
        floodRiskData: floodMapData,
      }
      await generateLetterPdf(payload)

      setLoadingPage(false)
      setRunReport(false)
    } catch (error) {
      setLoadingPage(false)
      setRunReport(false)
      sendMessageToReactNative({ status: 'fail' })
      console.error('Error generating report:', error)
    } finally {
    }
  }

  function downloadReport() {
    var endpoint = '/get_report_by_report_id'
    var params = {
      session_key: localAuth.sessionKey,
      report_id: reportPDF.report_id,
    }
    setLoading(true)
    callAPI(endpoint, params).then((res) => {
      setLoading(false)
      if (res.status === 'fail') {
        toast.warn(res.msg)
        return
      } else if (res.status === 'expire') {
        toast.warn(res.msg)
        logout()
        return
      }
      const downloadLink = document.createElement('a')
      downloadLink.href = res.pdf
      downloadLink.download = 'Report - ' + reportPDF.download
      downloadLink.click()
    })
  }

  // permission
  const enablePropertyLines = checkAbility('property_lines') || isDemoUser
  const numberOfReport = getAbilityLimit('number_of_reports')
  const numberOfReportRemain = getAbilityOptionalLimit(
    'number_of_remaining_reports'
  )

  const enableReportGeneration = checkAbility('report_generation')
  const enableCustomRanches = checkAbility('custom_ranches_portfolio')
  const isTrial = localAuth.tier === ETierKey.Trial

  const showReport = !enableReportGeneration && !isTrial

  if (
    ranchParcels[ranch.ranch_id] === undefined ||
    ranchParcels[ranch.ranch_id].length === 0
  ) {
    return (
      <>
        {deletePopupModal && (
          <DeletePopupModal
            setDeletePopupModal={setDeletePopupModal}
            deletePopupModal={deletePopupModal}
            onDelete={() => {
              if (selectedRanch.ranch_id == ranch.ranch_id) setSelectedRanch({})
              onRanchDelete(ranch.ranch_id)
              clearRanchSelection()
            }}
            type={'Ranch'}
          />
        )}
        <div
          className={`relative w-full flex items-center justify-between text-black font-medium uppercase rounded transition duration-150 ease-in-out mt-2 mb-2 p-6 pt-10 ${
            isMobile ? 'text-xs' : 'text-sm'
          }`}
        >
          {ranch.mod_time ? (
            <Moment
              className="absolute top-2 right-2 bg-[#3377cc] text-white uppercase text-xs font-semibold rounded-md px-2 py-1 shadow-lg"
              fromNow
            >
              {ranch.mod_time}
            </Moment>
          ) : (
            <></>
          )}
          <div>
            {ranch.ranch_name}
            <FaTrash
              title="Remove this ranch from your portfolio"
              className="h-[14px] cursor-pointer text-red-500 inline"
              onClick={(event) => {
                event.stopPropagation()
                setDeletePopupModal(true)
              }}
            />
          </div>
          <div className="flex relative">
            <UpgradeLockIconLayout
              position={'w-fit -left-1 top-0'}
              className="min-h-4 bg-transparent"
              iconSize={{ width: 24, height: 24 }}
              show={!enableCustomRanches}
            />
            <button
              onClick={() => {
                clearRanchSelection()
                setSelectedRanch(ranch)
                navigate('/')
              }}
              disabled={!enableCustomRanches}
              className="bg-blue-600 text-white uppercase font-medium text-sm rounded shadow-md
              hover:bg-blue-700 hover:shadow-lg focus:bg-blue-700 focus:shadow-lg
              w-[180px] text-center transition duration-150 ease-in-out btn btn-custom
              disabled:cursor-not-allowed disabled:opacity-50
              "
            >
              Add Parcel(s)
            </button>
          </div>
        </div>
      </>
    )
  } else
    return (
      <>
        {deletePopupModal && (
          <DeletePopupModal
            setDeletePopupModal={setDeletePopupModal}
            deletePopupModal={deletePopupModal}
            onDelete={() => {
              if (selectedRanch.ranch_id == ranch.ranch_id) setSelectedRanch({})
              onRanchDelete(ranch.ranch_id)
              clearRanchSelection()
            }}
            type={'Ranch'}
          />
        )}
        {loadingPage && <Spinner />}
        {/* <RanchReport make={true} data={{}}/> */}
        {isMobile ? (
          <MobileRanchCardView
            ranchParcels={ranchParcels}
            ranch={ranch}
            loading={loading}
            summary={summary}
            reportPDF={reportPDF}
            downloadReport={downloadReport}
            onRunReportClick={onRunReportClick}
            hydraScoreColor={hydraScoreColor}
            scoreHoverText={scoreHoverText}
            setPopupContent={setPopupContent}
            isDemoUser={isDemoUser}
          />
        ) : (
          <>
            <div
              className={`relative w-full flex items-center justify-between text-black font-medium uppercase rounded transition duration-150 ease-in-out mt-2 mb-2 p-6 pt-10 ${
                isMobile ? 'text-xs' : 'text-sm'
              }`}
            >
              {ranch.mod_time ? (
                <Moment
                  className="absolute top-2 right-2 bg-[#3377cc] text-white uppercase text-xs font-semibold rounded-md px-2 py-1 shadow-lg"
                  fromNow
                >
                  {ranch.mod_time}
                </Moment>
              ) : (
                <></>
              )}
              <div className="relative">
                <div className="flex items-center justify-between">
                  <span className="text-lg font-medium">
                    {ranch.ranch_name}
                  </span>
                  <div className="flex items-center space-x-4">
                    <button
                      aria-label="Share"
                      onClick={(e) => {
                        const locations = ranchParcels[ranch.ranch_id].map(
                          (parcel) => {
                            return {
                              lat: parcel.data.geolocation.lat,
                              lon: parcel.data.geolocation.lng,
                            }
                          }
                        )
                        navigator
                          .share({
                            title: 'Hydra score parcel(s)',
                            text: 'Click link to see shared parcel(s)',
                            url: `https://app.hydrascore.com/?locations=${btoa(
                              JSON.stringify(locations)
                            )}`,
                          })
                          .catch((error) => {
                            console.error('Sharing failed', error)
                          })
                      }}
                      title="Share this parcel"
                      className="p-2 rounded-full hover:bg-gray-100" // Add padding and hover effects if necessary
                    >
                      <FaShare className="text-gray-600" />
                    </button>
                    <FaTrash
                      title="Remove this ranch from your portfolio"
                      className="h-[14px] cursor-pointer text-red-500"
                      onClick={(event) => {
                        event.stopPropagation()
                        setDeletePopupModal(true)
                      }}
                    />
                  </div>
                </div>
              </div>
              <div className="flex space-x-4">
                {Object.keys(reportPDF).length ? (
                  <a
                    className="flex items-center justify-between text-[#457b9d] text-m font-medium cursor-pointer"
                    onClick={downloadReport}
                  >
                    <IoMdDownload />
                    {reportPDF.download}
                  </a>
                ) : (
                  <></>
                )}
                {
                  <div className="relative">
                    <UpgradeLockIconLayout
                      position={'w-fit -left-1 top-0'}
                      className="min-h-4 bg-transparent"
                      iconSize={{ width: 24, height: 24 }}
                      show={showReport}
                    />

                    <button
                      ref={runReportRef}
                      onClick={onRunReportClick}
                      disabled={showReport}
                      className="btn btn-custom disabled:cursor-not-allowed disabled:opacity-50"
                    >
                      Run Report
                    </button>
                  </div>
                }
              </div>
            </div>
            {loading ? (
              <div
                className={`w-full text-center text-black font-medium uppercase rounded transition duration-150 ease-in-out mt-2 mb-2 ${
                  isMobile ? 'text-xs' : 'text-sm'
                }`}
              >
                <div className="w-full bg-black bg-opacity-50 flex items-center justify-center z-[2000]">
                  <div>
                    <img src={spinner} alt="Loading..." className="h-24" />
                  </div>
                </div>
              </div>
            ) : (
              <div
                className={`flex min-h-[162px] columns-7 justify-between items-center shadow-md hover:shadow-xl rounded-md overflow-hidden transition-shadow duration-150 m-[10px] pb-2 ${
                  isMobile ? 'text-xs' : 'text-sm'
                }`}
              >
                <div className="flex h-full min-h-[162px] flex-col text-center w-full items-center justify-start space-y-1">
                  <h2 className="underline relative ml-[20px]">
                    Ranch Hydra score
                    {/* Info button placed next to the "Hydra Score" text */}
                    {checkAbility('hydra_score') && (
                      <button
                        style={{
                          height: '20px',
                          width: '20px',
                          display: 'inline-flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          padding: 0,
                          marginLeft: '2px', // Adjust this margin to control the spacing between the text and the button
                          cursor: 'pointer',
                          backgroundColor: 'white',
                          borderRadius: '50%',
                          border: '1px solid #00ac9c',
                          boxShadow: '0 2px 5px rgba(0, 0, 0, 0.2)',
                          transition:
                            'box-shadow 0.3s ease, transform 0.3s ease',
                        }}
                        onClick={(e) => {
                          e.stopPropagation() // Prevent event bubbling
                          setPopupContent(summary['hover'])
                        }}
                        onMouseEnter={(e) =>
                          (e.currentTarget.style.boxShadow =
                            '0 4px 10px rgba(0, 0, 0, 0.3)')
                        }
                        onMouseLeave={(e) =>
                          (e.currentTarget.style.boxShadow =
                            '0 2px 5px rgba(0, 0, 0, 0.2)')
                        }
                      >
                        <FaCircleInfo color="#00ac9c" />
                      </button>
                    )}
                  </h2>

                  <div className="relative w-[160px]" title={summary['hover']}>
                    <>
                      <UpgradeLockIconLayout
                        className="h-full rounded-full items-center justify-center opacity-80"
                        iconSize={{ width: 24, height: 24 }}
                        show={!checkAbility('hydra_score')}
                      />
                      <div className="flex flex-col items-center justify-center py-2">
                        <div className="w-[70px]">
                          <CircularProgressbarWithChildren
                            value={
                              summary[
                                'Geometrically Weighted Aggregate HydraSCORE'
                              ] === 'NR'
                                ? 0
                                : summary[
                                    'Geometrically Weighted Aggregate HydraSCORE'
                                  ]
                            }
                            background
                            backgroundPadding={6}
                            styles={buildStyles({
                              backgroundColor: hydraScoreColor(
                                summary[
                                  'Geometrically Weighted Aggregate HydraSCORE'
                                ]
                              ),
                              pathColor: '#fff',
                              trailColor: 'transparent',
                            })}
                          >
                            <div className="text-white" style={{ fontSize: 9 }}>
                              Hydra
                            </div>
                            <strong
                              className="text-white text-xs"
                              style={{ fontSize: 25 }}
                            >
                              <span className={`${isDemoUser ? 'blur' : ''}`}>
                                {
                                  summary[
                                    'Geometrically Weighted Aggregate HydraSCORE'
                                  ]
                                }
                              </span>
                            </strong>
                            <div className="text-white" style={{ fontSize: 9 }}>
                              Score
                            </div>
                          </CircularProgressbarWithChildren>
                        </div>
                      </div>
                      <UpdateHydraScoreStatus
                        hs_value_changed={
                          (isNaN(
                            parseInt(
                              summary[
                                'Geometrically Weighted Aggregate HydraSCORE'
                              ]
                            )
                          )
                            ? 0
                            : parseInt(
                                summary[
                                  'Geometrically Weighted Aggregate HydraSCORE'
                                ]
                              )) -
                          (isNaN(parseInt(summary['old_hs_avg']))
                            ? 0
                            : parseInt(summary['old_hs_avg']))
                        }
                        hs_updated_time={summary['hs_updated_time']}
                        hs_changed={summary['hs_changed']}
                      />
                    </>
                  </div>
                </div>
                <div className="flex h-full min-h-[162px] flex-col text-center w-full items-center justify-start space-y-1">
                  <h2 className="underline relative ml-[20px]">
                    Ranch Soil score
                    {/* Info button placed next to the "Hydra Score" text */}
                    {checkAbility('soil_score') && (
                      <button
                        style={{
                          height: '20px',
                          width: '20px',
                          display: 'inline-flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          padding: 0,
                          marginLeft: '2px', // Adjust this margin to control the spacing between the text and the button
                          cursor: 'pointer',
                          backgroundColor: 'white',
                          borderRadius: '50%',
                          border: '1px solid #00ac9c',
                          boxShadow: '0 2px 5px rgba(0, 0, 0, 0.2)',
                          transition:
                            'box-shadow 0.3s ease, transform 0.3s ease',
                        }}
                        onClick={(e) => {
                          e.stopPropagation() // Prevent event bubbling
                          setPopupContent(
                            scoreHoverText(
                              'ss',
                              summary['Geometrically Weighted Aggregate SS'] ===
                                'NR'
                                ? 0
                                : summary['Geometrically Weighted Aggregate SS']
                            )
                          )
                        }}
                        onMouseEnter={(e) =>
                          (e.currentTarget.style.boxShadow =
                            '0 4px 10px rgba(0, 0, 0, 0.3)')
                        }
                        onMouseLeave={(e) =>
                          (e.currentTarget.style.boxShadow =
                            '0 2px 5px rgba(0, 0, 0, 0.2)')
                        }
                      >
                        <FaCircleInfo color="#00ac9c" />
                      </button>
                    )}
                  </h2>
                  <div className="relative w-[160px]" title={summary['hover']}>
                    <UpgradeLockIconLayout
                      className="h-full rounded-full items-center justify-center opacity-80"
                      iconSize={{ width: 24, height: 24 }}
                      show={!checkAbility('soil_score')}
                    />
                    <div>
                      <div className="flex flex-col items-center justify-center py-2">
                        <div className={'w-[70px] '}>
                          <CircularProgressbarWithChildren
                            value={
                              summary['Geometrically Weighted Aggregate SS'] ===
                              'NR'
                                ? 0
                                : summary['Geometrically Weighted Aggregate SS']
                            }
                            background
                            backgroundPadding={6}
                            styles={buildStyles({
                              backgroundColor: hydraScoreColor(
                                summary['Geometrically Weighted Aggregate SS']
                              ),
                              pathColor: '#fff',
                              trailColor: 'transparent',
                            })}
                          >
                            <div className="text-white" style={{ fontSize: 9 }}>
                              Soil
                            </div>
                            <strong
                              className="text-white text-xs"
                              style={{ fontSize: 25 }}
                            >
                              <span className={`${isDemoUser ? 'blur' : ''}`}>
                                {summary['Geometrically Weighted Aggregate SS']}
                              </span>
                            </strong>
                            <div className="text-white" style={{ fontSize: 9 }}>
                              Score
                            </div>
                          </CircularProgressbarWithChildren>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="text-center w-full">
                  <div className="text-center w-full min-h-[60px]">
                    <h2>Total Acres</h2>
                    <p className="font-semibold">
                      <span className={`${isDemoUser ? 'blur' : ''}`}>
                        {summary['Total Acres']
                          .toFixed(2)
                          .toString()
                          .replace(/\B(?=(\d{3})+(?!\d))/g, ',')}{' '}
                        ac
                      </span>
                    </p>
                  </div>
                </div>
                <div className="text-center w-full">
                  <div className="text-center w-full min-h-[60px]">
                    <h2>Low Hydra Score Acres</h2>
                    <p className="font-semibold">
                      <span className={`${isDemoUser ? 'blur' : ''}`}>
                        {summary['Acres Poor Rating'] === 'NR'
                          ? 'Not Yet Rated'
                          : summary['Acres Poor Rating']
                              .toFixed(2)
                              .toString()
                              .replace(/\B(?=(\d{3})+(?!\d))/g, ',') +
                            'ac (' +
                            (
                              (summary['Acres Poor Rating'] /
                                summary['Total Acres']) *
                              100
                            ).toFixed(2) +
                            '%)'}{' '}
                      </span>
                    </p>
                  </div>
                </div>
                <div className="text-center w-full">
                  <div className="text-center w-full min-h-[60px]">
                    <h2>Low Soil Score Acres</h2>
                    <p className="font-semibold">
                      <span className={`${isDemoUser ? 'blur' : ''}`}>
                        {summary['Acres Poor Rating SS'] === 'NR'
                          ? 'Not Yet Rated'
                          : summary['Acres Poor Rating SS']
                              .toFixed(2)
                              .toString()
                              .replace(/\B(?=(\d{3})+(?!\d))/g, ',') +
                            'ac (' +
                            (
                              (summary['Acres Poor Rating SS'] /
                                summary['Total Acres']) *
                              100
                            ).toFixed(2) +
                            '%)'}{' '}
                      </span>
                    </p>
                  </div>
                </div>
              </div>
            )}
          </>
        )}

        {selectedRanch.ranch_id == ranch.ranch_id &&
          Object.keys(ranchApnSource).length > 0 &&
          Object.keys(ranchApnLayer).length > 0 &&
          Object.keys(ranchApnOutlineLayer).length > 0 &&
          Object.keys(ranchApnLabelLayer).length > 0 &&
          mapBounds[0].length > 0 && (
            <>
              <div className="w-full aspect-[1108/400] z-10 overflow-x-hidden overflow-y relative">
                {runReport && (
                  <div className="w-full h-[400px] flex flex-row absolute z-0">
                    <GenerateFloodMaps
                      parcels={ranchParcels[selectedRanch.ranch_id]}
                      localAuth={localAuth}
                      longitude={(mapBounds[0][0] + mapBounds[1][0]) / 2}
                      latitude={(mapBounds[0][1] + mapBounds[1][1]) / 2}
                      setFlooddReportData={setFloodMapData}
                      makres={ranchParcels[selectedRanch.ranch_id].map(
                        (parcel) => ({
                          lat: parcel.data.geolocation.lat,
                          lon: parcel.data.geolocation.lng,
                        })
                      )}
                    />
                  </div>
                )}
                <div className="absolute z-10 w-full aspect-[1108/400] overflow-x-hidden ">
                  <MapProvider>
                    <Map
                      id="ranch-aerial-view"
                      ref={mapRef}
                      onLoad={onMapLoad}
                      onIdle={onMapIdle}
                      initialViewState={{
                        longitude: (mapBounds[0][0] + mapBounds[1][0]) / 2, // -120.84801513068955,
                        latitude: (mapBounds[0][1] + mapBounds[1][1]) / 2, //37.05929755303834,
                        zoom: isMobile ? 11.5 : 14,
                      }}
                      scrollZoom={false}
                      dragPan={false}
                      doubleClickZoom={false}
                      style={{ height: '100%', width: '100%' }}
                      preserveDrawingBuffer={true}
                    >
                      <Source
                        id="google_earth_hybrid"
                        type="raster"
                        tiles={[
                          'https://mt1.google.com/vt/lyrs=y&x={x}&y={y}&z={z}',
                        ]}
                        tileSize={256}
                      >
                        <Layer {...layerStyle} />
                      </Source>
                      {mapRef.current && (
                        <Source {...ranchApnSource}>
                          {enablePropertyLines && <Layer {...ranchApnLayer} />}
                          {enablePropertyLines && (
                            <Layer {...ranchApnOutlineLayer} />
                          )}
                        </Source>
                      )}
                    </Map>
                  </MapProvider>
                </div>
              </div>

              <div
                key={ranch.ranch_id}
                className="min-h-[100px] justify-between items-center shadow-md hover:shadow-lg rounded-md transition-shadow duration-150 m-[10px] overflow-x-auto"
              >
                <div className="relative">
                  <ul className="grid grid-flow-col overflow-x-auto max-w-full">
                    {ranchParcels[ranch.ranch_id].map((parcel) => (
                      <div
                        key={parcel.id}
                        className="min-w-[300px] max-w-[400px]"
                      >
                        <ParcelCardView
                          page={'/portfolio'}
                          id={parcel.id}
                          property={parcel}
                          onRanchParcelDelete={() =>
                            onRanchParcelDelete(
                              parcel.id,
                              parcel.feature.properties.ranch_id,
                              parcel.feature.properties.parcel_ref_id
                            )
                          }
                          onEdit={() => onEdit(parcel.id)}
                          onPropertyClicked={onPropertyClicked}
                          handlePropertyMouseOver={handlePropertyMouseOver}
                          handlePropertyMouseOut={handlePropertyMouseOut}
                          isDemoUser={isDemoUser}
                          setLoading={setLoading}
                          setPopupContent={setPopupContent}
                        />
                      </div>
                    ))}
                  </ul>
                </div>
              </div>
            </>
          )}

        <div
          className="flex min-h-[20px] cursor-pointer items-center justify-center rounded-md overflow-hidden m-[10px]"
          onClick={() => {
            if (selectedRanch.ranch_id == ranch.ranch_id) setSelectedRanch({})
            else setSelectedRanch(ranch)
          }}
        >
          {selectedRanch.ranch_id == ranch.ranch_id ? (
            <MdOutlineExpandLess />
          ) : (
            <MdOutlineExpandMore />
          )}
        </div>
      </>
    )
}

const UpdateHydraScoreStatus = ({
  hs_value_changed,
  hs_updated_time,
  hs_changed,
}) => {
  if (!hs_changed) return
  const config =
    hs_value_changed > 0
      ? {
          cls: 'text-primary border-primary',
          icon: (
            <svg
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M11.8065 7.52627L8.47313 4.19294C8.40973 4.13224 8.33497 4.08467 8.25313 4.05294C8.09082 3.98626 7.90877 3.98626 7.74647 4.05294C7.66463 4.08467 7.58987 4.13224 7.52647 4.19294L4.19313 7.52627C4.13097 7.58843 4.08167 7.66222 4.04803 7.74344C4.01438 7.82465 3.99707 7.9117 3.99707 7.99961C3.99707 8.17714 4.0676 8.3474 4.19313 8.47294C4.31867 8.59847 4.48893 8.669 4.66646 8.669C4.844 8.669 5.01426 8.59847 5.1398 8.47294L7.33313 6.27294V11.3329C7.33313 11.5097 7.40337 11.6793 7.52839 11.8043C7.65342 11.9294 7.82299 11.9996 7.9998 11.9996C8.17661 11.9996 8.34618 11.9294 8.4712 11.8043C8.59623 11.6793 8.66647 11.5097 8.66647 11.3329V6.27294L10.8598 8.47294C10.9218 8.53542 10.9955 8.58502 11.0767 8.61887C11.158 8.65271 11.2451 8.67014 11.3331 8.67014C11.4211 8.67014 11.5083 8.65271 11.5895 8.61887C11.6708 8.58502 11.7445 8.53542 11.8065 8.47294C11.869 8.41096 11.9185 8.33723 11.9524 8.25599C11.9862 8.17475 12.0037 8.08761 12.0037 7.99961C12.0037 7.9116 11.9862 7.82446 11.9524 7.74322C11.9185 7.66198 11.869 7.58825 11.8065 7.52627Z"
                fill="#00AC9C"
              />
            </svg>
          ),
        }
      : {
          cls: 'text-[#EF3826] border-[#EF3826]',
          icon: (
            <svg
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M11.8065 7.52667C11.7445 7.46418 11.6708 7.41459 11.5895 7.38074C11.5083 7.34689 11.4211 7.32947 11.3331 7.32947C11.2451 7.32947 11.158 7.34689 11.0767 7.38074C10.9955 7.41459 10.9218 7.46418 10.8598 7.52667L8.66647 9.72667V4.66667C8.66647 4.48986 8.59623 4.32029 8.4712 4.19526C8.34618 4.07024 8.17661 4 7.9998 4C7.82299 4 7.65342 4.07024 7.52839 4.19526C7.40337 4.32029 7.33313 4.48986 7.33313 4.66667V9.72667L5.1398 7.52667C5.01426 7.40113 4.844 7.33061 4.66646 7.33061C4.48893 7.33061 4.31867 7.40113 4.19313 7.52667C4.0676 7.6522 3.99707 7.82247 3.99707 8C3.99707 8.17753 4.0676 8.3478 4.19313 8.47333L7.52647 11.8067C7.58987 11.8674 7.66463 11.9149 7.74647 11.9467C7.82627 11.9819 7.91255 12.0002 7.9998 12.0002C8.08705 12.0002 8.17333 11.9819 8.25313 11.9467C8.33497 11.9149 8.40973 11.8674 8.47313 11.8067L11.8065 8.47333C11.869 8.41136 11.9185 8.33762 11.9524 8.25638C11.9862 8.17515 12.0037 8.08801 12.0037 8C12.0037 7.91199 11.9862 7.82486 11.9524 7.74362C11.9185 7.66238 11.869 7.58864 11.8065 7.52667Z"
                fill="#EF3826"
              />
            </svg>
          ),
        }

  return (
    <div className="flex flex-col gap-1">
      <div
        className={`rounded-xl whitespace-nowrap px-2 py-1 border flex flex-row items-center justify-center w-fit ${config.cls}`}
      >
        <p className="font-semibold">SCORE UPDATED</p>
        {config.icon}
      </div>
      <p className="text-xs">
        {new Date(hs_updated_time)
          .toLocaleDateString('en-US', {
            month: '2-digit',
            day: '2-digit',
            year: 'numeric',
            hour: 'numeric',
            minute: '2-digit',
            hour12: true,
          })
          .replace(',', '')}
      </p>
    </div>
  )
}
